import {
  FormatterCallbackFunction,
  TooltipFormatterCallbackFunction,
  VerticalAlignValue,
} from 'highcharts';

import { BaseChart } from '@/components/Charts';

interface Series {
  name?: string;
  data: { y: number; color?: string }[];
}

type SeriesByTab = Record<string, Series[]>;

type CategoriesByTab = Record<string, string[]>;

interface TabConfig {
  label: string;
  value: string;
}

interface StackedColumnChartProps {
  title: string;
  series: Series[] | SeriesByTab;
  categories: string[] | CategoriesByTab;
  customColors?: string[];
  labelFormatter?: FormatterCallbackFunction<Highcharts.Series>;
  formatValue?: (val: number) => string | JSX.Element;
  headerTooltip?: string;
  hasTotal?: boolean;
  subtitle?: string;
  headerStats?: { label: string; value: number }[];
  tooltipFormatter?: TooltipFormatterCallbackFunction;
  tabsList?: TabConfig[];
  legendVerticalAlignment?: VerticalAlignValue;
  titleClassName?: string;
}

export const StackedColumnChart = ({
  customColors,
  labelFormatter,
  legendVerticalAlignment,
  ...rest
}: StackedColumnChartProps) => {
  return (
    <BaseChart
      chartType="column"
      customOptions={{
        ...(customColors ? { colors: customColors } : {}),
        plotOptions: {
          column: {
            borderRadius: 0,
            stacking: 'normal',
            dataLabels: {
              enabled: false,
            },
          },
        },
        legend: {
          ...(labelFormatter ? { labelFormatter } : {}),
          ...(legendVerticalAlignment
            ? { verticalAlign: legendVerticalAlignment }
            : {}),
          useHTML: true,
        },
      }}
      {...rest}
    />
  );
};
